'use client';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';

var _excluded = ["locale", "messageFormatter", "currencyFormatter", "getDisplayNamesObject", "phoneFormatter", "addressFormatter", "exampleGenerator", "dateTimeFormatter", "dateInputMaskFormat", "children"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IntlContext = React.createContext(null);
var IntlProvider = function (_ref) {
  var locale = _ref.locale,
    messageFormatter = _ref.messageFormatter,
    currencyFormatter = _ref.currencyFormatter,
    getDisplayNamesObject = _ref.getDisplayNamesObject,
    phoneFormatter = _ref.phoneFormatter,
    addressFormatter = _ref.addressFormatter,
    exampleGenerator = _ref.exampleGenerator,
    dateTimeFormatter = _ref.dateTimeFormatter,
    dateInputMaskFormat = _ref.dateInputMaskFormat,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(IntlContext.Provider, {
    value: _objectSpread$1({
      locale: locale,
      messageFormatter: messageFormatter,
      currencyFormatter: currencyFormatter,
      getDisplayNamesObject: getDisplayNamesObject,
      phoneFormatter: phoneFormatter,
      addressFormatter: addressFormatter,
      exampleGenerator: exampleGenerator,
      dateTimeFormatter: dateTimeFormatter,
      dateInputMaskFormat: dateInputMaskFormat
    }, rest)
  }, children);
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getFormattedMessage = function (intlContext, defaultMessage, id, variables) {
  if (!id) {
    return defaultMessage;
  }
  if (!(intlContext && intlContext.messageFormatter)) {
    return id;
  }
  return intlContext.messageFormatter({
    id: id
  }).format(variables);
};
var getCurrencyMaskOptions = function (intlContext, maskOptions, currencyType) {
  if (intlContext && intlContext.currencyFormatter) {
    var currencyFormat = intlContext.currencyFormatter({
      currency: currencyType
    });
    var currencyPartsArr = currencyFormat.formatToParts(1000);
    var _getIntlCurrencyPatte = getIntlCurrencyPattern(currencyPartsArr),
      intlMaskOptions = _getIntlCurrencyPatte.intlMaskOptions,
      intlCurrencyPrefix = _getIntlCurrencyPatte.intlCurrencyPrefix,
      intlCurrencySuffix = _getIntlCurrencyPatte.intlCurrencySuffix;

    //set mask-options padFractionalZeros to false and scale to 0 if currency does not support fractional values
    var currencyFormatOptions = currencyFormat.resolvedOptions();
    if (currencyFormatOptions.maximumFractionDigits === 0) {
      intlMaskOptions.padFractionalZeros = false;
      intlMaskOptions.scale = 0;
    }
    return {
      currencyMaskOptions: _objectSpread(_objectSpread({
        padFractionalZeros: true
      }, intlMaskOptions), maskOptions),
      intlCurrencyPrefix: intlCurrencyPrefix,
      intlCurrencySuffix: intlCurrencySuffix
    };
  }
  return {
    currencyMaskOptions: maskOptions
  };
};
function getIntlCurrencyPattern(currencyPartsArr) {
  var intlMaskOptions = {
    mask: Number
  };
  var intlCurrencyPrefix = '';
  var intlCurrencySuffix = '';
  currencyPartsArr.forEach(function (_ref, idx) {
    var type = _ref.type,
      value = _ref.value;
    switch (type) {
      case 'currencySymbol':
        if (idx === 0) {
          intlCurrencyPrefix = value;
        } else {
          intlCurrencySuffix = value;
        }
        break;
      case 'currency':
        if (idx === 0) {
          intlCurrencyPrefix = value;
        } else {
          intlCurrencySuffix = value;
        }
        break;
      case 'group':
        intlMaskOptions.thousandsSeparator = value;
        break;
      case 'fraction':
        intlMaskOptions.scale = value.length;
        break;
      case 'decimal':
        intlMaskOptions.radix = value;
        break;
    }
  });
  return {
    intlMaskOptions: intlMaskOptions,
    intlCurrencyPrefix: intlCurrencyPrefix,
    intlCurrencySuffix: intlCurrencySuffix
  };
}

export { IntlContext, IntlProvider, getCurrencyMaskOptions, getFormattedMessage };
